import { __awaiter } from "tslib";
import readyState from 'ready-state';
import '@slickdeals/blueprint-twig/javascript/patterns/dealContentListModule';
import '@slickdeals/blueprint-twig/javascript/patterns/dealLink';
import '../patterns/inlineResponse';
import { initPage } from '../utilities/initPage';
import { initInclickTracking } from '../utilities/eventTracking';
import { inclickSources } from '../utilities/inclickSources';
import { CONTAINER_TYPES, initViewableImpressions, } from '../utilities/initViewableImpressions';
initPage();
readyState.domready.then(() => __awaiter(void 0, void 0, void 0, function* () {
    const dealCard = 'tr[id^="sdpostrow_"]';
    const container = document.querySelector('.forumwrap');
    if (container) {
        initInclickTracking(container, dealCard, {
            containerName: 'Thread List',
            containerType: CONTAINER_TYPES.feed,
            getActionSource: () => inclickSources.DEAL_TITLE,
        });
    }
    if (!container) {
        return;
    }
    const dealElements = Array.from(document.querySelectorAll('.bp-p-dealLink[data-thread-id]'));
    dealElements.forEach((el) => {
        var _a;
        const row = el.closest(dealCard);
        if (!row) {
            return;
        }
        row.setAttribute('data-uniqueid', (_a = el.dataset.threadId) !== null && _a !== void 0 ? _a : '');
    });
    const deals = dealElements.map((el, index) => {
        var _a;
        return ({
            uniqueId: el.getAttribute('data-thread-id') || '',
            dealTitle: ((_a = el.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || '',
            listPriceText: el.getAttribute('data-list-price') || '',
            finalPriceText: el.getAttribute('data-final-price') || '',
            itemIndex: index + 1,
            isExpired: el.getAttribute('data-is-expired') === '1',
        });
    });
    const trackingData = {
        containerId: '',
        containerName: 'Thread List',
        containerType: CONTAINER_TYPES.feed,
    };
    const { trackVisibleDeals } = initViewableImpressions(container, [dealCard], trackingData, deals, 'feed');
    trackVisibleDeals();
}));
